export const AVAILABILITY_HIGH_DEMAND_MODE = 'availability-high-demand-mode';
export const AVAILABILITY_CLOSING_AWARENESS = 'availability-closing-awareness';

export const FEATURE_FLAG_CACHE_EXPIRY_IN_MIN = 10;

export const defaultHighDemand = {
  availability_preparation_time_adjustment_enabled: false,
  availability_preparation_time_stepper_enabled: false,
  allowed_availability_prep_times: [2, 4, 6, 8, 10],
  busy_mode_durations: [15, 30],
  high_demand_mode_duration_minutes: 30,
  high_demand_mode_suggestion_enabled: false,
};

export const defaultClosingAwareness = {
  enabled: false,
  targets: {},
  sound_frequency_seconds: undefined,
  overlay_frequency_minutes: undefined,
};
